module.exports = __webpack_public_path__ + "img/coffee.7efc2b23.svg";